import { render, staticRenderFns } from "./insuranceinvoices.vue?vue&type=template&id=95961d22&scoped=true"
import script from "./insuranceinvoices.vue?vue&type=script&lang=js"
export * from "./insuranceinvoices.vue?vue&type=script&lang=js"
import style0 from "./insuranceinvoices.vue?vue&type=style&index=0&id=95961d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95961d22",
  null
  
)

export default component.exports